import styled from 'styled-components';
import {colorPalette, defaultSize, viewSize} from '../../config';
import {
	mainDesktopImg,
	maintabletImg,
	secondSectionImg,
	mainmobileImg,
} from '../../config/images';

export const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const ResponsiveTitle = styled.div`
	font-size: ${(props) => props.fontSize.desktop};
	font-family: ${(props) => props.fontFamily};
	color: ${(props) => props.color};
	font-weight: ${(props) => props.fontWeight};
	margin-bottom: ${(props) => props.marginBottom};

	@media (max-width: 768px) {
		font-size: ${(props) => props.fontSize.tablet};
	}

	@media (max-width: 480px) {
		font-size: ${(props) => props.fontSize.mobile};
	}
`;
export const FirstSection = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	background-image: url(${(props) =>
		props.bgImg ? props.bgImg.desktop : mainDesktopImg});
	width: 100%;
	background-repeat: no-repeat;
	background-size: cover;
	background-position: top;
	height: ${(props) =>
		props.height ? props.height.desktop : 'calc(100vh - 80px)'};
	justify-content: space-between;
	@media screen and (max-width: ${viewSize.tablet}) {
		background-image: url(${(props) =>
			props.bgImg ? props.bgImg.desktop : maintabletImg});
		background-size: cover;
		background-position: none;
	}
	@media screen and (max-width: ${viewSize.mobile}) {
		background-image: url(${(props) =>
			props.bgImg ? props.bgImg.desktop : mainmobileImg});
	}
`;
export const MarathonInfoImage = styled.img`
	max-width: 100%;
	width: 700px;
	margin-bottom: 20px;
	@media (max-width: 768px) {
		max-width: 90%;
		margin-bottom: 15px;
	}
`;
export const FirstTextWrapper = styled.div`
	text-align: left;
	width: 100%;
	max-width: ${defaultSize.desktopContainer};
	margin: 10rem auto 0;
	display: flex;
	flex-direction: column;
	box-sizing: border-box;

	> button {
		position: absolute;
		width: 8rem;
		height: 45px;
		margin-top: 11%;
		margin-left: 2%;
	}

	@media screen and (max-width: ${viewSize.tablet}) {
		padding-left: 73px;
		margin: 10rem auto 0;

		> button {
			width: 152px;
			margin-top: 16%;
			margin-left: 0;
		}
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		margin: 30px 0 0 0;
		padding-left: 0;

		> button {
			width: 104px;
			height: 36px;
			margin-top: 36%;
			margin-left: 10%;
		}
	}
`;

export const DateWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 98%;
	max-width: ${defaultSize.desktopContainer};
	margin: 0 auto 60px;
	@media screen and (max-width: ${viewSize.tablet}) {
		margin: 3rem auto;
	}
	@media screen and (max-width: ${viewSize.mobile}) {
		margin: 1rem auto;
	}
`;

export const DateTextWrapper = styled.div`
	margin-bottom: 1rem;
	@media screen and (max-width: ${viewSize.mobile}) {
		padding-left: 20px;
	}
`;

export const DateItemWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
`;

export const DateItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-direction: column;
	height: 6rem;

	@media screen and (max-width: ${viewSize.mobile}) {
		width: 50%;
		margin: 2rem 0;
	}
`;

export const SecondSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 5.5rem auto 7rem auto;
	width: 98%;

	@media screen and (max-width: ${viewSize.tablet}) {
		max-width: ${defaultSize.tabletContainer};
		margin: 60px auto 80px auto;
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		max-width: ${defaultSize.mobileContainer};
	}
`;

export const InfoWrapper = styled.div`
	display: flex;
	width: 100%;
	max-width: ${defaultSize.desktopContainer};
	margin-bottom: 4rem;

	@media screen and (max-width: ${viewSize.tablet}) {
		flex-direction: column;
		width: 100%;
	}
	@media screen and (max-width: ${viewSize.mobile}) {
		width: 95%;
	}
`;

export const InfoTextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 20%;

	> span {
		margin-bottom: 1rem;
	}

	@media screen and (max-width: ${viewSize.tablet}) {
		width: 100%;
	}
	@media screen and (max-width: ${viewSize.mobile}) {
	}
`;

export const ImgTextWrapper = styled.div`
	display: flex;
	width: 80%;
	flex-wrap: wrap;
	justify-content: space-around;

	> div > div {
		margin-top: 1rem;
	}

	> div {
		margin: 1rem;
	}
	@media screen and (max-width: ${viewSize.tablet}) {
		width: 100%;
	}
	@media screen and (max-width: ${viewSize.mobile}) {
		> div {
			margin: 2rem;
		}
	}
`;

export const SupportWrapper = styled.div`
	display: flex;
	// flex-direction: column;
	flex-wrap: wrap;
	justify-content: center;
	width: 100%;
	align-items: center;
	max-width: ${defaultSize.desktopContainer};
	background-color: ${colorPalette.primary};
	border-radius: 1rem;
	padding: 1rem 0;
	min-height: 7rem;

	@media screen and (max-width: ${viewSize.tablet}) {
		max-width: ${defaultSize.tabletContainer};
		min-height: auto;
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		flex-direction: column;
		width: 95%;
	}
`;

export const Support = styled.div`
	display: flex;
	// flex-direction: column;
	flex-wrap: wrap;
	align-items: center;
	text-align: center;
	// justify-content: space-evenly;
	justify-content: center;
	width: auto;
	min-width: 300px;
	//margin: auto;
	margin: 10px 0;

	> img {
		margin: 0 11px;
		height: 57px;
	}
	@media screen and (max-width: ${viewSize.tablet}) {
		> img {
			margin: 0 6px;
			height: 35px;
		}
	}
	@media screen and (max-width: ${viewSize.mobile}) {
		width: 100%;
		margin: 1rem auto;
		> img {
			margin: 1rem 0;
		}
	}
`;

export const SupportText = styled.div`
	background-color: ${colorPalette.neonbtn};
	color: white;
	padding: 5px 15px;
	margin-right: 15px;
	font-weight: 700;
	border-radius: 20px;
	display: inline-block;

	@media screen and (max-width: ${viewSize.mobile}) {
		margin-bottom: 10px;
		font-size: 14px;
	}
`;
export const SupportContent = styled.div`
	color: white;
	display: flex;
	flex-direction: column;
	margin: 10px 0;

	@media screen and (max-width: ${viewSize.mobile}) {
		width: 90%;
		text-align: center;
	}
`;
export const SupportImg = styled.img`
	${(props) => (props.desktop ? `display : inline;` : `display : none;`)}
	max-width: 110px;
	height: auto;
	margin: 10px auto;

	@media screen and (max-width: ${viewSize.tablet}) {
		${(props) => (props.tablet ? `display : inline;` : `display : none;`)}
	}
	@media screen and (max-width: ${viewSize.mobile}) {
		${(props) => (props.mobile ? `display : inline;` : `display : none;`)}
	}
`;

export const ThirdSection = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	// background-image: url(${(props) =>
		props.bgImg ? props.bgImg.desktop : secondSectionImg});
	background: ${colorPalette.primary}
	background-repeat: no-repeat;
	background-size: cover;
	padding: 3rem 0;
	margin-bottom: 1rem;
	color: white;
`;

export const ThirdTextWrapper = styled.div`
	max-width: ${defaultSize.desktopContainer};

	width: 98%;

	@media screen and (max-width: ${viewSize.tablet}) {
		max-width: ${defaultSize.tabletContainer};
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		max-width: ${defaultSize.mobileContainer};
	}

	@media screen and (max-width: 1100px) {
		margin: 1rem;
		max-width: ${defaultSize.tabletContainer};
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		max-width: ${defaultSize.mobileContainer};
	}
`;

export const ThirdCardWrapper = styled.div`
	max-width: ${defaultSize.desktopContainer};
	display: flex;
	justify-content: space-between;
	margin : auto;
	width: 98%;
	margin-top:30px;

	@media screen and (max-width: ${viewSize.tablet}) {
		max-width: ${defaultSize.tabletContainer};
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		max-width: ${defaultSize.mobileContainer};
	}
	@media screen and ( max-width : 1100px) {
		flex-direction: column;
		align-items: center;
		
		> div {
			margin : 1rem 0;
		}
	}
	
	
}
`;

export const FourthSection = styled.div`
	padding: 80px 0 133px 0;
	align-items: center;
	justify-content: center;
	display: flex;
	flex-direction: column;
	width: 98%;
	margin: auto;

	@media screen and (max-width: ${viewSize.tablet}) {
		max-width: ${defaultSize.tabletContainer};
	}

	@media screen and (max-width: ${viewSize.mobile}) {
		max-width: ${defaultSize.mobileContainer};
	}
`;
export const FifthSection = styled.div``;
export const YoutubeWrapper = styled.div`
	width: 80%;
	max-width: 1000px;
	margin: 2rem auto;

	@media only screen and (max-width: ${viewSize.tablet}) {
		width: 90%;
	}

	@media only screen and (max-width: ${viewSize.mobile}) {
		width: 95%;
	}
`;
export const YoutubeSection = styled.div`
	width: 100%;
	max-width: ${defaultSize.desktopContainer};
	// padding: 0 1rem;
	box-sizing: border-box;

	@media screen and (max-width: ${viewSize.tablet}) {
		max-width: ${defaultSize.tabletContainer};
	}
`;

// export const YoutubeTitle = styled.h2`
// 	font-size: 26px;
// 	color: ${colorPalette.primary};
// 	margin-bottom: 1.5rem;
// 	font-family: 'Gmarket';

// 	@media screen and (max-width: ${viewSize.mobile}) {
// 		font-size: 22px;
// 		margin-bottom: 1rem;
// 	}
// `;

export const YoutubeContainer = styled.div`
	position: relative;
	width: 100%;
	padding-top: 56.25%; /* 16:9 비율 */
	overflow: hidden;
	border-radius: 1rem;

	iframe {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border: none;
	}
`;
